import { computed } from 'vue';
import { useStore } from 'vuex';

/**
 * @returns {{
 *   isReady: import('vue').ComputedRef<boolean | null>,
 *   averageRating: import('vue').ComputedRef<number | null>,
 *   totalCount: import('vue').ComputedRef<number | null>;
 *   countPerRating: import('vue').ComputedRef<CountPerRating[]>;
 *   sliders: import('vue').ComputedRef<ReviewStatisticsSlider[]>;
 *   photos: import('vue').ComputedRef<{ url: String }[]>;
 * }}
*/
export function useReviewsStatistics() {
  const store = useStore();
  return {
    isReady: computed(() => !!store.state.reviewsStore.statistics),
    averageRating: computed(() => store.state.reviewsStore.statistics?.averageRating || null),
    totalCount: computed(() => store.state.reviewsStore.statistics?.totalCount || null),
    countPerRating: computed(() => {
      const { statistics } = store.state.reviewsStore;
      if (!statistics?.countPerRating) return [];

      return [5, 4, 3, 2, 1].map((rating) => {
        const ratingData = statistics.countPerRating.find(
          /**
          * @param {CountPerRating} x
          */
          (x) => x.rating === rating,
        ) || {};
        const { count = 0, percentage = 0 } = ratingData;

        return { rating, count, percentage };
      });
    }),
    sliders: computed(() => store.state.reviewsStore.statistics?.sliders || []),
    photos: computed(() => store.state.reviewsStore?.photos || []),
  };
}

export default useReviewsStatistics;
